export enum ControlType {
	FreeText = 'FreeText',
	Number = 'Number',
	SingleChoice = 'SingleChoice',
	MultipleChoices = 'MultipleChoices'
}
